import React from 'react';
import { Row, Col,ListGroup,ListGroupItem,Button } from 'reactstrap';
import Config from '../../Core/Config.js';
import {framework} from 'saffroncodejs';
import Axios from 'axios';
import BimeManager from '../../Core/BimeManager';
import UserManager from '../../Core/UserManager';
import {libs,ui} from 'saffroncodejs';
import './Khesarat.css'

var PageManager = framework.PageManager ;
class HavaleKHesarat extends React.Component {
    
    constructor(props) {
        
        
        super(props);
        

        var urlParams = PageManager.decodePageParams(props);
        this.currentSodurId = this.encodeSodurId(urlParams[0]);
        this.dmgmord = this.encodeSodurId(urlParams[1]);
        this.bmshasli = this.encodeSodurId(urlParams[2]);
        this.soudor = this.encodeSodurId(urlParams[3]);
        //alert('urlParams'+ this.urlParams)

        //this.renderSwitch = this.renderSwitch.bind(this);
        this.state ={ 
            isloading:true,
            // activeTab: 1,//1:? 2:? 3:?,
            data:[{"MlHvId":57580471,"HVNo":2,"PrvNo":2,"SodurHvId":969,"DmgMored":null,"DmgMoredText":null,"HVKindText":"تسويه","ReshteCaption":"حوادث انفرادي","HvbabtText":"خسارت","HVAmount":1265000,"BimeShodeCmnId":null,"PersonName":"اعظم احمدي کد 2379247","PersonCodemelli":"0490705324","ErrorMessage":null}],
            
        }
    
    
        this.state.data = [] ;
        //this.state.btns=[];
       
       this.loadDetail();
            
    }
    
    encodeSodurId(encodedId)
    {
        return encodedId;
    }

    componentWillReceiveProps(props)
    {
        var urlParams = PageManager.decodePageParams(props);
        this.currentSodurId = this.encodeSodurId(urlParams[0]);
        this.dmgmord = this.encodeSodurId(urlParams[1]);
        this.bmshasli = this.encodeSodurId(urlParams[2]);
        this.soudor = this.encodeSodurId(urlParams[3]);
        this.loadDetail();
    }

    loadDetail()
    {
        //alert("this.currentSodurId : "+this.currentSodurId);
        Axios.post(BimeManager.reactRedirectDomain,
            BimeManager.makeBody("/NovinInsuranceServices/Cmn/api/Person/LossHV",
           
                {Codemelli: UserManager.MelliCode(),SodurPrvId: this.currentSodurId ,DmgMored: this.dmgmord,bimeShodeAsliCmnId: this.bmshasli,Reshte: this.soudor}
            ),
            BimeManager.header())
            .then((result)=>{
              // console.log("result.data : ",JSON.stringify(result.data));
                this.setState({data:result.data,isloading:false})//
                console.log("data2 : ",this.state.data);
            })
            .catch((error) => { alert(error) })   
    }

    pagechange(Sodur,DmgMored,sodurHvId) {
       // alert(this.soudor);
      // alert(DmgMored);
        
        switch (this.soudor) {
            case '8':
                PageManager.changePage(Config.p_barbaridakhelikh,[Sodur]);
                break;
            case '5':
                   // PageManager.changePage(Config.p_sales,[Sodur]);
                 if(DmgMored=== 2)
                    {
                      PageManager.changePage(Config.p_salesmali,[Sodur]);
                     }
                     if(DmgMored=== 1)
                     {
                       PageManager.changePage(Config.p_sales,[sodurHvId]);
                      }
                      if(DmgMored=== 3)
                     {
                       PageManager.changePage(Config.p_salessarneshin,[Sodur]);
                      }
                break;
            //case '5':
           // if(DmgMoredText==='سرنشین')
           // {
                //PageManager.changePage(Config.p_salessarneshin,[Sodur]);
           // }
               // break;
            case '1':
                PageManager.changePage(Config.p_atashsuzisanati,[Sodur]);
                break;
            case '2':
                PageManager.changePage(Config.p_atashsuzigheirsanati,[Sodur]);
                break;
                case '4':
                PageManager.changePage(Config.p_badanekh,[Sodur]);
                break;
                case '20':
                PageManager.changePage(Config.p_havadesguruhikh,[Sodur]);
                break;
                case '21':
                PageManager.changePage(Config.p_darmankh,[Sodur,DmgMored]);
                break;
                case '17':
                PageManager.changePage(Config.p_havadesenferadikh,[Sodur]);
                break;
                case '7':
                PageManager.changePage(Config.p_barbarivaredatikh,[Sodur]);
                break;
                case '6':
                PageManager.changePage(Config.p_barbarisaderatikh,[Sodur]);
                break;
                case '12':
                PageManager.changePage(Config.p_pezeshkankh,[Sodur]);
                break;
                case '13':
                PageManager.changePage(Config.p_pirapezeshkankh,[Sodur]);
                break;
                case '11':
                PageManager.changePage(Config.p_hamlonaghlkh,[Sodur]);
                break;
                case '9':
                PageManager.changePage(Config.p_abniekh,[Sodur]);
                break;
                case '101':
                PageManager.changePage(Config.p_sanatibazarganikh,[Sodur]);
                break;
                case '14':
                PageManager.changePage(Config.p_omranikh,[Sodur]);
                break;
                case '10':
                PageManager.changePage(Config.p_karfarmasakhtemanikh,[Sodur]);
                break;
                case '15':
                PageManager.changePage(Config.p_madanikh,[sodurHvId]);
                break;
                case '103':
                PageManager.changePage(Config.p_omrsarmayegozarikh,[Sodur]);
                break;
                case '34':
                PageManager.changePage(Config.p_axakh,[Sodur]);
                break;
                case '225':
                PageManager.changePage(Config.p_soskh,[Sodur]);
                break;
                case '53':
                PageManager.changePage(Config.p_mashinalatkh,[Sodur]);
                break;
                case '55':
                PageManager.changePage(Config.p_tajhizatelektronikikh,[sodurHvId]);
                break;
                case '56':
                PageManager.changePage(Config.p_sazehayetakmilshodekh,[sodurHvId]);
                break;
                case '54':
                PageManager.changePage(Config.p_shekastmashinalatkh,[sodurHvId]);
                break;
                case '51':
                PageManager.changePage(Config.p_tamamkhatarkh,[sodurHvId]);
                break;
                case '57':
                PageManager.changePage(Config.p_sayerkh,[sodurHvId]);
                break;
                case '91':
                PageManager.changePage(Config.p_havapeymakh,[Sodur]);
                break;
                case '107':
                if(DmgMored===59)
                {

                PageManager.changePage(Config.p_poolkh,[sodurHvId]);
                }
                if(DmgMored===58)
                {
                   
                    PageManager.changePage(Config.p_poolsandoghkh,[sodurHvId]);
                }
                break;
                case '3':
                PageManager.changePage(Config.p_maskunikh,[Sodur]);
                break;
                case '213':
                PageManager.changePage(Config.p_anbarkh,[Sodur]);
                break
                case '110':
                PageManager.changePage(Config.p_marhunatikh,[Sodur]);
                break;
                case '35':
                PageManager.changePage(Config.p_mapfreekh,[Sodur]);
                break;
                case '95':
                PageManager.changePage(Config.p_asbkh,[Sodur]);
                break;
            default:
                alert('محتوای مورد نظر موجود نمی باشد')
        }
        

    }

    render() {
       // const datas = this.state.data;
        
       
        
       
        //alert("نام رشته"+this.state.data.ReshteCaption)
        //console.log("data : ",this.state.data);
        if (this.state.isloading===true)
        {
           
         return (
            
                <ui.Preloader/>
            
         
             )
            }
            
        return (
            <div>
            <Row>
            <Col sm="12" className="alignRight title">
                <h4>حواله خسارت</h4>
            </Col>
        </Row>
            <div className="container ListOfList khesarat">
             
              
                                <ListGroup>
                                
                                    <ListGroupItem >
                                        
                                       {this.state.data.length!==0 ? this.state.data.map((dataa)=>{
                                           return(<div className="border-List">
                                           <Row >
                                          
                                            <Col sm="12" className="alignRight"><span className="bold-head">کد رایانه حواله در مالی:</span>{dataa.MlHvId}</Col>
                                            <Col sm="12" className="alignRight"><span className="bold-head">شماره حواله:</span>{dataa.HVNo}</Col>
                                            <Col sm="12" className="alignRight"><span className="bold-head">شماره پرونده:</span>{dataa.PrvNo}</Col>
                                            <Col sm="12" className="alignRight"><span className="bold-head">کد رایانه حواله در رشته:</span>{dataa.SodurHvId}</Col>
                                            <Col sm="12" className="alignRight"><span className="bold-head">مورد خسارت:</span>{dataa.DmgMoredText}</Col>
                                            <Col sm="12" className="alignRight"><span className="bold-head">نوع حواله:</span>{dataa.HVKindText}</Col>
                                            <Col sm="12" className="alignRight"><span className="bold-head">عنوان رشته:</span>{dataa.ReshteCaption}</Col>
                                            <Col sm="12" className="alignRight"><span className="bold-head">بابت حواله:</span>{dataa.HvbabtText}</Col>
                                            <Col sm="12" className="alignRight"><span className="bold-head">مبلغ حواله:</span>{libs.StringFunctions.currancyPrint(dataa.HVAmount)+('ریال')}</Col>
                                            <Col sm="12" className="alignCenter"><Button className="" onClick={() => { this.pagechange(dataa.SodurHvId,dataa.DmgMored,dataa.SodurHvId)}}>مشاهده جزئیات</Button></Col>
                                            </Row>
                                            <br/>
                                                          </div>
                                                 )
                                               
                                                }  )
                                                :
                                                <Row >
                                                    <Col sm="12" className="alignCenter">
                                                    لیست حواله ها ی شما خالی می باشد
                                                    </Col>
                                                </Row>
                                            }
                                            
                                    
                                        </ListGroupItem>
                               
                                </ListGroup>


               

            </div>
            </div>


    
);
        
}


}

export default HavaleKHesarat;


// WEBPACK FOOTER //
// ./src/components/Khesarat/HavaleKHesarat.js